import cn from 'clsx'

import './VerticalDivider.scss'

interface HorizontalDividerProps {
  className?: string
  margin?: 'small' | 'default'
}

export default function VerticalDivider({
  className,
  margin = 'default',
}: HorizontalDividerProps) {
  return (
    <div
      className={cn(
        className,
        `VerticalDivider VerticalDivider_margin_${margin}`
      )}
    />
  )
}
